module.exports = __webpack_public_path__ + "front/img/poster4.cc2e8b76.jpg";